import React, { Component } from 'react';

import pc from '../../pc';

import { Cell, Grid } from '../../components/layout';

class SubmitBudgetForm extends Component {
  state = {
    payload: {
      name: '',
      email: '',
      gender: '',
      ageRange: 'Age Range',
      postcode: '',
      reason: '',
      brightideas: '',
    },
    shouldShowErrorMessage: false,
  }

  handleInputChange = (key, value) => {
    this.setState({
      payload: {
        ...this.state.payload,
        [key]: value,
      }
    });
  }

  /**
   * TODO Abstract the core of this validation code to a helper of some kind...
   */
  handleFormSubmit = (event) => {
    event.preventDefault();

    const { onSubmit } = this.props;
    const { payload } = this.state;

    // const postcodeCheck = pc.filter((item) => {
    //   return item.postcode_no_space.toLowerCase() === this.state.payload.postcode.toLowerCase() || item.postcode.toLowerCase() === this.state.payload.postcode.toLowerCase()
    // })

    let valid = true;

    Object.keys(payload).forEach(field => {
      const $input = this.budgetForm.querySelector(`[data-input-ref="${field}"]`);
      const $genderLabel = this.budgetForm.querySelector('.c-form-control__label--gender');

      // Test for empty values
      if (field !== 'brightideas' && field !== 'email' && field !== 'postcode' && field !== 'reason' && field !== 'ageRange' && field !== 'gender' && field !== 'name') {
        if (payload[field] === '') {
          valid = false;
          $input.classList.add('u-is-error');
          return;
        }
      }

      // Ensure age range has been selected
      // if (field === 'ageRange') {
      //   if (payload[field] === 'Age Range') {
      //     valid = false;
      //     $input.classList.add('u-is-error');
      //     return;
      //   }
      // }

      // Ensure postcode has been entered
      // if (field === 'postcode') {
      //   if (payload[field] === '') {
      //     valid = false;
      //     $input.classList.add('u-is-error');
      //     return;
      //   }
      // }

      // Ensure gender has been selected
      // if (field === 'gender') {
      //   if (payload[field] === '') {
      //     valid = false;
      //     $genderLabel.querySelector('.u-error-message').classList.add('u-error-message--visible');
      //     return;
      //   } else {
      //     $genderLabel.querySelector('.u-error-message').classList.remove('u-error-message--visible');
      //   }
      // }

      // Ensure email regex is matched
      if (field === 'email') {
        const pattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

        if (payload[field] !== '') {
          if (!pattern.test(payload[field])) {
            valid = false;
            $input.classList.add('u-is-error');
            return;
          }
        }
      }

      // Ensure postcode is valid
      // if (field === 'postcode') {
      //   const pattern = /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[0-9][A-Za-z]{2})/;

      //   if (!pattern.test(payload[field].replace(/\s+/g, ''))) {
      //     valid = false;
      //     $input.classList.add('u-is-error');
      //     return;
      //   }

      //   if (postcodeCheck.length <= 0) {
      //     valid = false;
      //     $input.classList.add('u-is-error');
      //     return;
      //   }
      // }

      // Assume that there are no errors so we can hide the messages
      if ($input) {
        if ($input.classList.contains('u-is-error')) {
          $input.classList.remove('u-is-error');
        }
      }
    });

    if (!valid) {
      this.setState({ shouldShowErrorMessage: true });
    } else {
      this.setState({ shouldShowErrorMessage: false });

      // Finally if the user wants to remain annonymous then we set their display
      // name to 'Annonymous'.
      this.setState({
        payload: {
          ...this.state.payload,
          name: this.state.payload.name === '' ? 'Anonymous' : this.state.payload.name,
        }
      }, () => onSubmit(this.state.payload));
    }
  }

  render() {
    const {
      shouldShowErrorMessage,
      payload: {
        name,
        email,
        postcode,
        ageRange,
      }
    } = this.state;

    return (
      <form
        noValidate
        id="send-budget-form"
        className="o-form"
        onSubmit={e => this.handleFormSubmit(e)}
        ref={budgetForm => (this.budgetForm = budgetForm)}
      >
        <Grid>
          {
            shouldShowErrorMessage &&
            <Cell size={{ desktop: '12', phone: '6' }}>
              <p className="u-text-error">
                Some of the information you have provided doesn't look right.<br />
                Please check your details and try again.
              </p>
            </Cell>
          }
          <Cell size={{ desktop: '4', phone: '6' }}>
            <div className="c-form-control c-form-control--reason">
              <label className="c-form-control__label">
                Reason
              </label>
              <textarea
                name="reason"
                id="reason"
                data-input-ref="reason"
                placeholder="Enter Reason"
                onChange={(e) => this.handleInputChange('reason', e.target.value)}
              />
              <label className="c-form-control__label">
                Bright Ideas
              </label>
              <textarea
                name="brightideas"
                id="brightideas"
                data-input-ref="brightideas"
                placeholder="Enter any bright ideas you have about how we could save money or generate income."
                onChange={(e) => this.handleInputChange('brightideas', e.target.value)}
              />
            </div>
          </Cell>

          <Cell size={{ desktop: '8', phone: '6' }}>
            <Grid>
              <Cell size={{ desktop: '3', phone: '6' }}>
                <div className="c-form-control">
                  <label className="c-form-control__label">Display Name</label>
                  <input
                    type="text"
                    placeholder="Enter Name"
                    data-input-ref="name"
                    defaultValue={name}
                    onChange={(e) => this.handleInputChange('name', e.target.value)}
                  />
                </div>
              </Cell>

              <Cell size={{ desktop: '5', phone: '6' }}>
                <div className="c-form-control">
                  <label className="c-form-control__label">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter Email"
                    data-input-ref="email"
                    defaultValue={email}
                    onChange={(e) => this.handleInputChange('email', e.target.value)}
                  />
                </div>
              </Cell>

              <Cell size={{ desktop: '4', phone: '6' }}>
                <div className="c-form-control">
                  <label className="c-form-control__label c-form-control__label--gender">
                    Gender
                    <span className="u-error-message u-text-error u-float-right">Please select a gender</span>
                  </label>

                  <label className="c-form-control__label c-form-control__label--inline">
                    <input
                      type="radio"
                      className="c-form-control__faux-check-input"
                      name="gender"
                      value="m"
                      onChange={(e) => this.handleInputChange('gender', e.target.value)}
                    />
                    <span className="c-form-control__faux-check">Male</span>
                  </label>

                  <label className="c-form-control__label c-form-control__label--inline">
                    <input
                      type="radio"
                      className="c-form-control__faux-check-input"
                      name="gender"
                      value="f"
                      onChange={(e) => this.handleInputChange('gender', e.target.value)}
                    />
                    <span className="c-form-control__faux-check">Female</span>
                  </label>

                  <label className="c-form-control__label c-form-control__label--inline">
                    <input
                      type="radio"
                      className="c-form-control__faux-check-input"
                      name="gender"
                      value="n"
                      onChange={(e) => this.handleInputChange('gender', e.target.value)}
                    />
                    <span className="c-form-control__faux-check">Prefer not to say</span>
                  </label>

                  <label className="c-form-control__label c-form-control__label--inline">
                    <input
                      type="radio"
                      className="c-form-control__faux-check-input"
                      name="gender"
                      value="o"
                      onChange={(e) => this.handleInputChange('gender', e.target.value)}
                    />
                    <span className="c-form-control__faux-check">Other</span>
                  </label>
                </div>
              </Cell>
            </Grid>

            <Grid>
              <Cell size={{ desktop: '4', phone: '6' }}>
                <div className="c-form-control c-form-control--no-margin">
                  <label className="c-form-control__label">
                    Age Range
                  </label>
                  <select
                    id="age-range"
                    name="age-range"
                    data-input-ref="ageRange"
                    className="c-select"
                    defaultValue={ageRange}
                    onChange={(e) => this.handleInputChange('ageRange', e.target.value)}
                  >
                    <option disabled={true}>Age Range</option>
                    <option>Under 16</option>
                    <option>16-25</option>
                    <option>26-40</option>
                    <option>41-65</option>
                    <option>Over 65</option>
                  </select>
                </div>
              </Cell>

              <Cell size={{ desktop: '4', phone: '6' }}>
                <div className="c-form-control c-form-control--no-margin">
                  <label className="c-form-control__label">
                    Postcode
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Postcode e.g. NE1 2TE"
                    data-input-ref="postcode"
                    defaultValue={postcode}
                    onChange={(e) => this.handleInputChange('postcode', e.target.value)}
                  />
                </div>
              </Cell>

              <Cell size={{ desktop: '4', phone: '6' }} alignment="bottom">
                <div className="c-form-control c-form-control--no-margin">
                  <button
                    className="c-button"
                    style={{
                      position: 'relative',
                      top: '-4px'
                    }}
                  >
                    Submit Budget
                  </button>
                </div>
              </Cell>
            </Grid>
          </Cell>
        </Grid>
      </form>
    );
  }
}

export default SubmitBudgetForm;



// WEBPACK FOOTER //
// ./src/components/forms/SubmitBudgetForm.jsx